import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a list of search filters, opening only one filter at a time.
 *
 * @example
 * const SearchFilter1 = ({ open, clickHandler }) => {
 *   return (
 *     <SearchFilter
 *       name='Search Filter 1'
 *       queryParameterName='search1'
 *       options={{ a: 'a', b: 'b', c: 'c' }}
 *       open={open}
 *       clickHandler={clickHandler}
 *       applyFilterLabel='Apply'
 *       clearLabel='Clear'
 *       searchPlaceholder='Search the list'
 *     />
 *   );
 * };
 *
 * const SearchFilter2 = ({ open, clickHandler }) => {
 *   return (
 *     <SearchFilter
 *       name='Search Filter 2'
 *       queryParameterName='search2'
 *       options={{ d: 'd', e: 'e' }}
 *       open={open}
 *       clickHandler={clickHandler}
 *       applyFilterLabel='Apply'
 *       clearLabel='Clear'
 *       searchPlaceholder='Search the list'
 *     />
 *   );
 * };
 *
 * return (
 *  <SearchFilterList
 *    searchFilters={[
 *      SearchFilter1,
 *      SearchFilter2,
 *    ]}
 *  />
 * );
 */
const SearchFilterList = ({ searchFilters }) => {
  const [activeId, setActiveId] = useState(null);

  const onClick = (id) => {
    setActiveId(prev => {
      if (prev === id) {
        return null;
      }
      else {
        return id;
      }
    });
  };

  return (
    <div className='search-filter-list--container'>
      {
        searchFilters.map((searchFilter, index) => {
          const open = index === activeId;
          const clickHandler = () => onClick(index);
          const renderedSearchFilter = searchFilter({ open, clickHandler });

          return (
            <Fragment key={index}>
              {renderedSearchFilter}
            </Fragment>
          );
        })
      }
    </div>
  );
};

SearchFilterList.propTypes = {
  /**
   * an array of components that implement the SearchFilter component and only
   * accept props "open" and "clickHandler"
   */
  searchFilters: PropTypes.array.isRequired,
};

export default SearchFilterList;
